// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UO-z","hovered":"VO-z","hoverImage":"WO-z","mainImage":"XO-z","imageNoBackground":"YO-z","fullSizeImage":"ZO-z"};